/** A plain blow (fx 'bite', 'slash', 'crush', 'cleave'): the weapon's swing, or a beast's bite. */
import { registerFx } from './registry';

registerFx(['bite', 'slash', 'crush', 'cleave'], (host) => ({
  skill: ({ src, style, humanoid, brk }) => {
    if (humanoid) host.swingArc(src, style, brk ? '255,160,64' : '255,120,110');
    else host.fx.push(host.bite(src));
    host.sfx.swing();
  },
}));
